import { render, staticRenderFns } from "./InvoicesHistoryStatusAccount.vue?vue&type=template&id=70922304&scoped=true&"
import script from "./InvoicesHistoryStatusAccount.vue?vue&type=script&lang=js&"
export * from "./InvoicesHistoryStatusAccount.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesHistoryStatusAccount.vue?vue&type=style&index=0&id=70922304&scoped=true&lang=css&"
import style1 from "./InvoicesHistoryStatusAccount.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70922304",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70922304')) {
      api.createRecord('70922304', component.options)
    } else {
      api.reload('70922304', component.options)
    }
    module.hot.accept("./InvoicesHistoryStatusAccount.vue?vue&type=template&id=70922304&scoped=true&", function () {
      api.rerender('70922304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Customer/InvoicesHistoryStatusAccount.vue"
export default component.exports